const getErrMsg = (statusCode, errData) => {
  switch (statusCode) {
    case 422: {
      let errMsg = 'Please fulfill your form!';
      const message = errData?.message;
      if (typeof message === 'string' && message) {
        errMsg = message;
      } else if (message && typeof message === 'object') {
        const joined = Object.values(message).flat().filter(Boolean).join(', ');
        if (joined) errMsg = joined;
      }
      return errMsg;
    }
    case 404:
      return 'Resource not found!';
    case 403:
      return 'Forbidden, ask our staff for more details!';
    default:
      return "We've got something error!";
  }
};

/**
 * Normalize API 422 payloads into the shape expected by form helpers
 * (`errorMessage` / `hasError` look up `errors[field]`).
 * Backend may return field errors under `message` or `errors`.
 */
export const normalizeValidationErrors = (error) => {
  if (!error) return null;
  const { message, errors } = error;
  let fieldErrors = errors || null;
  if (
    !fieldErrors &&
    message &&
    typeof message === 'object' &&
    !Array.isArray(message)
  ) {
    fieldErrors = message;
  }
  return {
    ...error,
    errors: fieldErrors || {},
  };
};

export default getErrMsg;
